var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EMessagePurpose } from "@/types/messaging";
var OTP_TEMPLATE_TYPE = "OTP";
/** Per language, whether the account's provider approved a template for `purpose`. */
export var templateApprovalRows = function (check, purpose, languages) {
    var _a, _b;
    var approved = (_b = (_a = check === null || check === void 0 ? void 0 : check.approved_templates) === null || _a === void 0 ? void 0 : _a[purpose]) !== null && _b !== void 0 ? _b : [];
    return Array.from(new Set(__spreadArray(__spreadArray([], languages, true), approved, true)))
        .sort()
        .map(function (language) { return ({ language: language, approved: approved.includes(language) }); });
};
/** The purpose a template of `type` is sent for. */
export var templatePurpose = function (type) {
    return type === OTP_TEMPLATE_TYPE ? EMessagePurpose.OTP : EMessagePurpose.NOTICE;
};
